import { defineMeta } from '@/registry/types';

export const drawerMeta = defineMeta({
  name: 'Drawer',
  level: 'organism',
  category: 'navigation',
  classification: 'mui-overrides',
  description: 'Side panel sliding in from an edge for navigation, details or filters. Themed MUI Drawer.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Drawer',
  muiDocs: 'https://mui.com/material-ui/react-drawer/',
  a2uiEquivalent: 'Drawer',
  importPath: '@/organisms/Drawer',
  requiredProps: ['open'],
  optionalProps: ['anchor', 'variant', 'onClose'],
  supportedStates: ['temporary', 'persistent', 'permanent'],
  designTokens: ['colors', 'shadows', 'typography'],
  accessibility: ['Temporary drawers trap focus; Esc closes; provide a heading.'],
  usageExamples: [
    '<Drawer anchor="right" open={open} onClose={close}><Typography variant="h6">prod-db-01</Typography><Typography variant="body1">Finding detail</Typography></Drawer>',
  ],
  rules: [
    'Give every drawer a `Typography variant="h6"` heading and `body1` supporting copy. It is a landmark, not a floating box.',
  ],
  antiPatterns: ['Do not use a temporary drawer for permanent primary navigation.'],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Detail panels, filter panels, mobile navigation'],
  whenNotToUse: ['Short confirmations (use Dialog)'],
});

export default drawerMeta;
